import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=5f49b47e&scoped=true&"
import script from "./provider.vue?vue&type=script&lang=js&"
export * from "./provider.vue?vue&type=script&lang=js&"
import style0 from "./provider.vue?vue&type=style&index=0&id=5f49b47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49b47e",
  null
  
)

export default component.exports